import { get, put, post } from '@api/request';

export async function fetchSalesAnalysisConfig(
  { appraisalService },
  authenticationToken,
  { pYear },
) {
  const url = `${appraisalService}/appraisal/salesanalysisconfig/${pYear}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateSalesAnalysisConfig(
  { appraisalService },
  authenticationToken,
  { pYear, payload },
) {
  if (payload.lastUpdate === undefined) {
    const url = `${appraisalService}/appraisal/salesanalysisconfig`;
    const { body } = await post(authenticationToken, url, {
      ...payload,
      pYear: pYear,
    });
    return body;
  } else {
    const url = `${appraisalService}/appraisal/salesanalysisconfig/${pYear}`;
    const { body } = await put(authenticationToken, url, payload);
    return body;
  }
}

export async function fetchSalesAnalysisTransitionsCodefiles(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/salesanalysistranslations/codefiles`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchSalesAnalysisTransitionsMissingCodes(
  { appraisalService },
  authenticationToken,
  { year, codeFileName }
) {
  const url = `${appraisalService}/appraisal/salesanalysistranslations/${codeFileName}/${year}/missingcodes`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchSalesAnalysisTransitions(
  { appraisalService },
  authenticationToken,
  { year, codeFileName, }
) {
  const url = `${appraisalService}/appraisal/salesanalysistranslations/${codeFileName}/${year}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateSalesAnalysisTransition(
  { appraisalService },
  authenticationToken,
  { year, codeFileName, codeName, payload }
) {
  const url = `${appraisalService}/appraisal/salesanalysistranslations/${codeFileName}/${year}/${codeName}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function addSalesAnalysisTransitionMissingCodes(
  { appraisalService },
  authenticationToken,
  { year, codeFileName }
) {
  const url = `${appraisalService}/appraisal/salesanalysistranslations/${codeFileName}/${year}/missingcodesadd`;
  const { body } = await post(authenticationToken, url);
  return body;
}